// extracted by mini-css-extract-plugin
export default {"posCell":"catalogueProductsTable_posCell__cfyp4","input":"catalogueProductsTable_input__bSVcq"};